import { useAuthContext } from './use-auth-context';
import { isUserRole, DEFAULT_ROLE, type UserRole } from '../roles';

// ----------------------------------------------------------------------

type UseUserRoleResult = {
  role: UserRole | null;
  loading: boolean;
};

export function useUserRole(): UseUserRoleResult {
  const { user, loading } = useAuthContext();

  if (loading) {
    return { role: null, loading: true };
  }

  if (!user) {
    return { role: null, loading: false };
  }

  const raw = (user as { role?: unknown }).role;
  return { role: isUserRole(raw) ? raw : DEFAULT_ROLE, loading: false };
}
